import { all, put, call, takeLatest } from '@redux-saga/core/effects';
import {
  formatErrorMessage,
  handleErrorBasedOnCode,
  rejectErrorCodeHelper,
} from '../../util/helpers/registerRejectErrorCodeHelper';
import {
  CREATE_LEGAL_ENTITY_ADDRESS,
  CREATE_LEGAL_ENTITY_EIN,
  CREATE_LEGAL_ENTITY_NAME,
  CREATE_PERSON_ADDRESS,
  CREATE_PERSON_BACKUP_WITH_HOLDINGS,
  CREATE_PERSON_BIRTHDAY,
  CREATE_PERSON_COUNTRY,
  CREATE_PERSON_MARTIAL_STATUS,
  CREATE_PERSON_NAME,
  CREATE_PERSON_SSN,
  CREATE_PERSON_PHONE,
  UPDATE_LEGAL_ENTITY_ADDRESS,
  UPDATE_LEGAL_ENTITY_EIN,
  UPDATE_LEGAL_ENTITY_NAME,
  UPDATE_PERSON_ADDRESS,
  UPDATE_PERSON_BACKUP_WITH_HOLDINGS,
  UPDATE_PERSON_BIRTHDAY,
  UPDATE_PERSON_COUNTRY,
  UPDATE_PERSON_MARTIAL_STATUS,
  UPDATE_PERSON_NAME,
  UPDATE_PERSON_SSN,
  UPDATE_PERSON_PHONE,
} from '../actions/person/personActionConstants';
import {
  createPersonAddressRequest,
  createPersonBackupWithHoldingsRequest,
  createPersonBirthdayRequest,
  createPersonCountryRequest,
  createPersonNameRequest,
  createPersonSSNRequest,
  updatePersonAddressRequest,
  updatePersonBackupWithHoldingsRequest,
  updatePersonBirthdayRequest,
  updatePersonCountryRequest,
  updatePersonNameRequest,
  updatePersonSSNRequest,
  createLegalEntityNameRequest,
  updateLegalEntityNameRequest,
  createLegalEntityEinRequest,
  updateLegalEntityEinRequest,
  createLegalEntityAddressRequest,
  updateLegalEntityAddressRequest,
  createPersonMartialStatusRequest,
  updatePersonMartialStatusRequest,
  createPersonPhoneRequest,
  updatePersonPhoneRequest,
} from '../../request/personRequests';
import {
  createLegalEntityAddressError,
  createLegalEntityAddressSuccess,
  createLegalEntityEinError,
  createLegalEntityEinSuccess,
  createLegalEntityNameError,
  createLegalEntityNameSuccess,
  createPersonAddressError,
  createPersonAddressSuccess,
  createPersonBirthdayError,
  createPersonBirthdaySuccess,
  createPersonCountryError,
  createPersonCountrySuccess,
  createPersonIsBackupWithHoldingsError,
  createPersonIsBackupWithHoldingsSuccess,
  createPersonMartialStatusError,
  createPersonMartialStatusSuccess,
  createPersonNameError,
  createPersonNameSuccess,
  createPersonSSNError,
  createPersonSSNSuccess,
  updateLegalEntityAddressError,
  updateLegalEntityAddressSuccess,
  updateLegalEntityEinError,
  updateLegalEntityEinSuccess,
  updateLegalEntityNameError,
  updateLegalEntityNameSuccess,
  updatePersonAddressError,
  updatePersonAddressSuccess,
  updatePersonBirthdayError,
  updatePersonBirthdaySuccess,
  updatePersonCountryError,
  updatePersonCountrySuccess,
  updatePersonIsBackupWithHoldingsError,
  updatePersonIsBackupWithHoldingsSuccess,
  updatePersonMartialStatusError,
  updatePersonMartialStatusSuccess,
  updatePersonNameError,
  updatePersonNameSuccess,
  updatePersonSSNError,
  updatePersonSSNSuccess,
  createPersonPhoneSuccess,
  createPersonPhoneError,
  updatePersonPhoneSuccess,
  updatePersonPhoneError,
} from '../actions/person/personActions';

function* createPersonName({ payload }) {
  try {
    const { data } = yield call(createPersonNameRequest, {
      ApplicationUid: payload?.ApplicationUid,
      data: payload.data,
      isPrimary: payload.isPrimary,
    });
    if (data) {
      yield put(createPersonNameSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createPersonNameError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* updatePersonName({ payload }) {
  try {
    const { data } = yield call(updatePersonNameRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(updatePersonNameSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updatePersonNameError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* createPersonSSN({ payload }) {
  try {
    const { data } = yield call(createPersonSSNRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(createPersonSSNSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createPersonSSNError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* updatePersonSSN({ payload }) {
  try {
    const { data } = yield call(updatePersonSSNRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(updatePersonSSNSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updatePersonSSNError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* createPersonAddress({ payload }) {
  try {
    const { data } = yield call(createPersonAddressRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(createPersonAddressSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(handleErrorBasedOnCode, error, payload.onError);
    }
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createPersonAddressError(errorMessage));
  }
}

function* updatePersonAddress({ payload }) {
  try {
    const { data } = yield call(updatePersonAddressRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(updatePersonAddressSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(handleErrorBasedOnCode, error, payload.onError);
    }
    const errorMessage = formatErrorMessage(error);
    yield put(updatePersonAddressError(errorMessage));
  }
}

function* createPersonBirthday({ payload }) {
  try {
    const { data } = yield call(createPersonBirthdayRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(createPersonBirthdaySuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createPersonBirthdayError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* updatePersonBirthday({ payload }) {
  try {
    const { data } = yield call(updatePersonBirthdayRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(updatePersonBirthdaySuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updatePersonBirthdayError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* createPersonCountry({ payload }) {
  try {
    const { data } = yield call(createPersonCountryRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(createPersonCountrySuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createPersonCountryError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError, errorMessage);
    }
  }
}

function* updatePersonCountry({ payload }) {
  try {
    const { data } = yield call(updatePersonCountryRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(updatePersonCountrySuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updatePersonCountryError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError, errorMessage);
    }
  }
}

function* createPersonBackupWithHoldings({ payload }) {
  try {
    yield call(createPersonBackupWithHoldingsRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonTargetType: payload.PersonTargetType,
      data: payload.data,
    });
    yield put(createPersonIsBackupWithHoldingsSuccess());
    if (payload?.onSuccess) {
      yield call(payload?.onSuccess);
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createPersonIsBackupWithHoldingsError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* updatePersonBackupWithHoldings({ payload }) {
  try {
    yield call(updatePersonBackupWithHoldingsRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonTargetType: payload.PersonTargetType,
      data: payload.data,
    });
    yield put(updatePersonIsBackupWithHoldingsSuccess());
    if (payload?.onSuccess) {
      yield call(payload?.onSuccess);
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updatePersonIsBackupWithHoldingsError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* createPersonPhone({ payload }) {
  try {
    const { data } = yield call(createPersonPhoneRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    yield put(createPersonPhoneSuccess(data));
    if (payload?.onSuccess) {
      yield call(payload?.onSuccess);
    }
  } catch (error) {
    const errorMessage = formatErrorMessage(error);
    yield put(createPersonPhoneError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError, errorMessage);
    }
  }
}

function* updatePersonPhone({ payload }) {
  try {
    const { data } = yield call(updatePersonPhoneRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    yield put(updatePersonPhoneSuccess(data));
    if (payload?.onSuccess) {
      yield call(payload?.onSuccess);
    }
  } catch (error) {
    const errorMessage = formatErrorMessage(error);
    yield put(updatePersonPhoneError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError, errorMessage);
    }
  }
}

function* createLegalEntityName({ payload }) {
  try {
    const { data } = yield call(createLegalEntityNameRequest, {
      ApplicationUid: payload?.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(createLegalEntityNameSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(payload?.onError);
    }
    if (payload.onError) {
      yield call(handleErrorBasedOnCode, error, payload.onError);
    }

    const errorMessage = yield call(formatErrorMessage, error);
    yield put(createLegalEntityNameError(errorMessage));
    yield call(payload.setError, errorMessage);
  }
}

function* updateLegalEntityName({ payload }) {
  try {
    const { data } = yield call(updateLegalEntityNameRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(updateLegalEntityNameSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    if (payload.onError) {
      yield call(payload?.onError);
      yield call(handleErrorBasedOnCode, error, payload.onError);
    }
    const errorMessage = yield call(formatErrorMessage, error);
    yield put(updateLegalEntityNameError(errorMessage));
    yield call(payload.setError, errorMessage);
  }
}

function* createLegalEntityEin({ payload }) {
  try {
    const { data } = yield call(createLegalEntityEinRequest, {
      ApplicationUid: payload?.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(createLegalEntityEinSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
        return;
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createLegalEntityEinError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* updateLegalEntityEin({ payload }) {
  try {
    const { data } = yield call(updateLegalEntityEinRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(updateLegalEntityEinSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
        return;
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updateLegalEntityEinError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* createLegalEntityAddress({ payload }) {
  try {
    const { data } = yield call(createLegalEntityAddressRequest, {
      ApplicationUid: payload?.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(createLegalEntityAddressSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
        return;
      }
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(handleErrorBasedOnCode, error, payload.onError);
      yield call(payload?.onError);
    }
    const errorMessage = formatErrorMessage(error);
    yield put(createLegalEntityAddressError(errorMessage));
  }
}

function* updateLegalEntityAddress({ payload }) {
  try {
    const { data } = yield call(updateLegalEntityAddressRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(updateLegalEntityAddressSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(handleErrorBasedOnCode, error, payload.onError);
      yield call(payload?.onError);
    }
    const errorMessage = formatErrorMessage(error);
    yield put(updateLegalEntityAddressError(errorMessage));
  }
}

function* createPersonMartialStatus({ payload }) {
  try {
    const { data } = yield call(createPersonMartialStatusRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(createPersonMartialStatusSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createPersonMartialStatusError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

function* updatePersonMartialStatus({ payload }) {
  try {
    const { data } = yield call(updatePersonMartialStatusRequest, {
      ApplicationUid: payload.ApplicationUid,
      PersonUid: payload.PersonUid,
      data: payload.data,
    });
    if (data) {
      yield put(updatePersonMartialStatusSuccess(data));
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updatePersonMartialStatusError(errorMessage));
    if (payload?.onError) {
      yield call(payload?.onError);
    }
  }
}

export default function* personSaga() {
  return yield all([
    takeLatest(CREATE_PERSON_NAME, createPersonName),
    takeLatest(UPDATE_PERSON_NAME, updatePersonName),
    takeLatest(CREATE_PERSON_SSN, createPersonSSN),
    takeLatest(UPDATE_PERSON_SSN, updatePersonSSN),
    takeLatest(CREATE_PERSON_ADDRESS, createPersonAddress),
    takeLatest(UPDATE_PERSON_ADDRESS, updatePersonAddress),
    takeLatest(CREATE_PERSON_BIRTHDAY, createPersonBirthday),
    takeLatest(UPDATE_PERSON_BIRTHDAY, updatePersonBirthday),
    takeLatest(CREATE_PERSON_COUNTRY, createPersonCountry),
    takeLatest(UPDATE_PERSON_COUNTRY, updatePersonCountry),
    takeLatest(
      CREATE_PERSON_BACKUP_WITH_HOLDINGS,
      createPersonBackupWithHoldings,
    ),
    takeLatest(
      UPDATE_PERSON_BACKUP_WITH_HOLDINGS,
      updatePersonBackupWithHoldings,
    ),
    takeLatest(CREATE_PERSON_MARTIAL_STATUS, createPersonMartialStatus),
    takeLatest(UPDATE_PERSON_MARTIAL_STATUS, updatePersonMartialStatus),
    takeLatest(CREATE_LEGAL_ENTITY_NAME, createLegalEntityName),
    takeLatest(UPDATE_LEGAL_ENTITY_NAME, updateLegalEntityName),
    takeLatest(CREATE_LEGAL_ENTITY_EIN, createLegalEntityEin),
    takeLatest(UPDATE_LEGAL_ENTITY_EIN, updateLegalEntityEin),
    takeLatest(CREATE_LEGAL_ENTITY_ADDRESS, createLegalEntityAddress),
    takeLatest(UPDATE_LEGAL_ENTITY_ADDRESS, updateLegalEntityAddress),
    takeLatest(CREATE_PERSON_PHONE, createPersonPhone),
    takeLatest(UPDATE_PERSON_PHONE, updatePersonPhone),
  ]);
}
